import React, { Component } from 'react';
import {Footer, SideNav, TopBar} from '../partials/layouts.js';
import {LogoutModal} from './logout.js';
import {Link} from 'react-router-dom';

class AlbumList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data          :[],
      isLoading     :true,
    };
  }

  async getAlbums() {
    try {
      const response = await fetch('/api/albums');
      const json = await response.json();
      this.setState({ data: json });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    this.getAlbums();
  }

  render() {

    const albums = this.state.data;
    if(!this.state.isLoading && albums.length){
      const album_list = albums.map((album)=>
          <div key={album.id} dataid={album.id} className="col-md-4 col-lg-3 col-xs-12">
            <div className="card">
              <div className="card-body album-cards">
                <Link to={`/photo-gallery/${album.id}`} id={album.id}>
                  <img src={album.cover_img_url} className="img-fluid" alt={album.name} />
                </Link>
              </div>
              <div className="card-footer text-center">
                <Link to={`/photo-gallery/${album.id}`} id={album.id} className="fw-bold">{album.name}</Link>
              </div>
            </div>
          </div>
      );
      return(
          <>
            <div className="album-cards">
              <div className="row">
                {album_list}
              </div>
            </div>
          </>
      );
    }
  }
}

function Albums() {
  return (
    <>
        <div id="wrapper">
            <SideNav />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopBar />
                    <div className="container-fluid">
                        <AlbumList />
                    </div>
                </div>
                <Footer />
            </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
        </a>
        <LogoutModal />
    </>
  );
}

export { Albums };
